<template>
  <div>
    <Dialogs :dialogs="dialogExamine" @dialogVisible="beforeClose">
      <template #desc>
        <div class="info_subject">
          <div class="info_subject_option">
            <div class="info_subject_option_title">开始周期</div>
            <el-date-picker
              style="width: 532px;height: 36px;"
              v-model="dialogExamine.date"
              type="month"
              @change="ExamineChange"
              value-format="yyyy/MM"
              format="yyyy/MM"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
        <div class="info_subject">
          <div class="info_subject_option">
            <div class="info_subject_option_title">考核人员</div>
            <div class="users_personnel" style="margin: 0">

              <div style="display: flex;flex-wrap: wrap;">
                <div
                  class="user_personnel"
                  v-for="(item, index2) in dialogExamine.userList"
                  :key="index2"
                  v-show="
                    dialogExamine.userList &&
                      dialogExamine.userList.length > 0
                  "
                  @click="contactCh(dialogExamine.userList, '1')"
                >
                  <div class="info_personnel">
                    <img
                      v-if="item.avatar != ''&& item.avatar !== null"
                      class="info_personnel_surname"
                      :src="item.avatar"
                    >
                    <div v-else class="info_personnel_surname">
                      {{item.name.substring(0, 1)}}
                    </div>
                    <div class="name_style" v-if="channel === 'wechat'"><ww-open-data type="userName" :openid="item.name" /></div>
                    <el-tooltip effect="dark" :content="item.name" placement="bottom-start" :open-delay="500" v-else>
                      <div class="name_style">{{item.name}}</div>
                    </el-tooltip>
                  </div>
                  <i
                    class="iconfont icon-shanchu del_icon"
                    @click.stop.stop="delUsers(dialogExamine.userList, index2, '1')"
                  />
                </div>
              </div>
              <i
                class="iconfont icon-jiahao2fill add_icon"
                style="margin:5px 0 0 10px"
                @click="contactCh(dialogExamine.userList, '1')"
              />
            </div>
          </div>
        </div>
        <div class="info_subject">
          <div class="info_subject_option">
            <div class="info_subject_option_title">评分模版</div>
            <el-select v-model="dialogExamine.templateValue" @change="templateChange" placeholder="请选择评分模版" style="width: 532px;height: 36px;">
              <el-option
                v-for="item in dialogExamine.templateOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <div class="info_subject">
          <div class="info_subject_option">
            <div class="info_subject_option_title">评分流程</div>
            <el-select v-model="dialogExamine.followValue" @change="followChange" placeholder="请选择评分流程" style="width: 532px;height: 36px;">
              <el-option
                v-for="item in dialogExamine.followOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <div v-if="roleData && roleData.length > 0">
          <div class="info_subject" v-for="(item, index) in roleData" :key="index">
            <div class="info_subject_option">
              <el-tooltip effect="dark" :content="item.name" placement="bottom-start" :open-delay="500">
                <div class="info_subject_option_title">{{item.name}}</div>
              </el-tooltip>
              <div class="users_personnel" style="margin: 0">

                <div style="display: flex;flex-wrap: wrap;">
                  <div
                    class="user_personnel"
                    v-for="(itemF, index2) in item.userList"
                    :key="index2"
                    v-show="
                      item.userList &&
                        item.userList.length > 0
                    "
                    @click="contactCh(item.userList, item.id)"
                  >
                    <div class="info_personnel">
                      <img
                        v-if="itemF.avatar != ''&& itemF.avatar != null"
                        class="info_personnel_surname"
                        :src="itemF.avatar"
                      >
                      <div v-else class="info_personnel_surname">
                        {{itemF.name.substring(0, 1)}}
                      </div>
                      <div class="name_style" v-if="channel === 'wechat'"><ww-open-data type="userName" :openid="itemF.name" /></div>
                      <el-tooltip effect="dark" :content="itemF.name" placement="bottom-start" :open-delay="500" v-else>
                        <div class="name_style">{{itemF.name}}</div>
                      </el-tooltip>
                    </div>
                    <i
                      class="iconfont icon-shanchu del_icon"
                      @click.stop.stop="delUsers(item, index2, '2')"
                    />
                  </div>
                </div>
                <i
                  class="iconfont icon-jiahao2fill add_icon"
                  style="margin:5px 0 0 10px"
                  @click="contactCh(item.userList, item.id)"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </Dialogs>
    <!-- 发起考核预览弹框 -->
    <Dialogs :dialogs="dialogInitiate" @dialogVisible="beforeClose">
      <template #desc>
        <div class="info_subject" style="min-height:260px;width: 100%;">
          <div v-if="dialogInitiate.tableData.length > 0" style="width: 98%;" class="table-box">
            <el-table
              :data="dialogInitiate.tableData"
              :header-cell-style="{
                background: '#F1F1F1 ',
                fontSize: '14px',
                colorr: '#999999'
              }"
              border
              :span-method="objectSpanMethod"
              :cell-class-name="getCellClassName"
            >
              <el-table-column
                prop="typeName"
                label="分类"
                width="150"
              >
                <template slot-scope="scope">
                  <div style="width: 100%;text-align: center;">{{scope.row.typeName}}</div>
                  <div style="width: 100%;text-align: center;">{{scope.row.typeScore}}%</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="content"
                label="考核内容"
                min-width="200"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.content"
                    placement="bottom"
                    popper-class="texttooltip"
                    :open-delay="500"
                  >
                    <div>{{scope.row.content}}</div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                v-for="(header, index) in tableHeaders"
                :key="index"
                :prop="header.name"
                min-width="200"
              >
                <template v-slot:header>
                  <div class="template_header">
                    <div v-html="header.label" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{header.label}}</div>
                  </div>
                </template>
                <template slot-scope="scope">
                  <div v-if="scope.row.fieldValueMap">
                    {{scope.row.fieldValueMap[header.prop]}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="score"
                label="分值"
                width="100"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.type === '0'">{{scope.row.taskNormalScore}}</div>
                  <div v-else>{{scope.row.score}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="controls"
                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <div style="display: flex;">
                    <!-- <span
                    style="color: $color_main;padding-right: 24px;"
                    @click="handleEdit(scope.$index, scope.row)"
                  >添加</span> -->
                    <!-- <span
                      style="color: #FF0000;"
                      @click="handleDelete(scope.$index, scope.row)"
                    >删除</span> -->
                    <el-tooltip
                      effect="dark"
                      content="添加考核"
                      placement="top"
                      popper-class="texttooltip"
                    >
                      <i
                        class="iconfont icon-jiahao2fill icon_btn"
                        v-if="scope.row.type !== '0'"
                        @click.stop="handleEdit(scope.$index, scope.row)"
                      />
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      content="删除"
                      placement="top"
                      popper-class="texttooltip"
                    >
                      <i
                        class="iconfont icon-shanchu1 icon_btn"
                        style="font-size: 15px;padding-left:10px"
                        @click.stop="handleDelete(scope.$index, scope.row)"
                      />
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else>
            <noDate />
          <!-- 请求超时 -->
          <!-- <timeout /> -->
          </div>
        </div>
      </template>
    </Dialogs>
    <!-- 添加考核项弹框 -->
    <Dialogs :dialogs="dialogaddExamine" @dialogVisible="cancelDialog2">
      <template #desc>
        <div class="info_subject">
          <div class="info_subject_option">
            <div class="info_subject_option_title">考核分类</div>
            <!-- @focus="sortChange" -->
            <el-select v-model="dialogaddExamine.sort" placeholder="请选择考核分类" style="width: 532px;" @change="sortSelect">
              <el-option
                v-for="item in dialogaddExamine.sortOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <div class="info_subject">
          <div class="info_subject_option">
            <div class="info_subject_option_title">说明</div>
            <el-input v-model="dialogaddExamine.standard" type="textarea" placeholder="请输入考核内容" style="width: 532px;" @change="FinstandardChange" class="area" />
          </div>
        </div>
        <div v-if="dialogaddExamine.fieldValueList && dialogaddExamine.fieldValueList.length > 0">
          <div class="info_subject" v-for="(item, index) in dialogaddExamine.fieldValueList" :key="index">
            <div class="info_subject_option">
              <div class="info_subject_option_title">{{item.name}}</div>
              <el-input
                style="width: 532px;"
                type="text"
                v-model="item.value"
                placeholder="请输入"
                @change="tempFieldsChange($event, item, index, dialogaddExamine.fieldValueList)"
              />
            </div>
          </div>
        </div>
        <div class="info_subject">
          <div class="info_subject_option">
            <div class="info_subject_option_title">分值</div>
            <el-input-number
              :min="0"
              style="width: 532px;"
              type="number"
              v-model="dialogaddExamine.score"
            />
          </div>
        </div>
      </template>
    </Dialogs>
    <!-- 正常逾期提前完成弹框 -->
    <Dialogs :dialogs="dialogFinsh" @dialogVisible="beforeClose">
      <template #desc>
        <div class="info_finsh" style="height: 700px;">
          <div v-if="dialogFinsh.tableData.length > 0">
            <el-table
              :data="dialogFinsh.tableData"
              :header-cell-style="{
                background: '#F1F1F1 ',
                fontSize: '14px',
                cursor: 'pointer',
                colorr: '#999999'
              }"
              :row-style="{ height: '38' }"
              :cell-class-name="returnName"
            >
              <el-table-column
                prop="projectName"
                label="项目名称"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.projectName"
                    placement="bottom"
                    popper-class="texttooltip"
                    :open-delay="500"
                  >
                    <div>{{scope.row.projectName}}</div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="taskname"
                label="任务名称"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.taskname"
                    placement="bottom"
                    popper-class="texttooltip"
                    :open-delay="500"
                  >
                    <div>{{scope.row.taskname}}</div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="score"
                label="负责人"
              >
                <!-- <template slot="header">得分
                <span style="color: #FF0000;">（20）</span>
              </template> -->
                <template slot-scope="scope">
                  <div v-if="scope.row.responseUserList && scope.row.responseUserList.length > 0">
                    <div v-for="(item, index) in scope.row.responseUserList" :key="index">
                      <span v-if="channel === 'wechat'">
                        <ww-open-data type="userName" :openid="item.name" />
                      </span>
                      <span v-else>{{item.name}}</span>
                      <span v-show="scope.row.responseUserList.length-1!=index">,</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                label="任务状态"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="scope-content" v-if="scope.row.taskType === '1'">
                    <span v-if="scope.row.status === '0'">未开始</span>
                    <span v-if="scope.row.status === '1'">未完成</span>
                    <span v-if="scope.row.status === '2'">已完成</span>
                    <span v-if="scope.row.status === '3'">待确认</span>
                  </div>
                  <div class="scope-content" v-else-if="scope.row.taskType === '0'">
                    <span v-if="scope.row.status === '0'">未指派</span>
                    <span v-if="scope.row.status === '1'">未完成</span>
                    <span v-if="scope.row.status === '2'">已完成</span>
                    <span v-if="scope.row.status === '3'">待确认</span>
                    <span v-if="scope.row.status === '4'">已终止</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="score"
                label="绩效"
                width="100"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.score}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else>
            <noDate />
          </div>
        </div>
      </template>
    </Dialogs>
  </div>
</template>

<script>
import Dialogs from '../../../components/common/dialog.vue'
import Vue from 'vue'
import noDate from '../nodate.vue'
import { findUserIds } from '../../../utils/api/user'
import choose from 'dingtalk-jsapi/api/biz/contact/choose' // PC 通讯录选人 meritsSave
import { feishuContactChoose } from '../../../utils/fsConfig'
import { meritsfindPre, automgetAddBefore, tempTypeList, meritSubmit, meritsSave, tempFieldFindList, findKpiTaskPageList, closeTaskKpi, ConfigDetail, getRoleByFlowId } from '../../../utils/api/kpiV2'
export default {
  components: {
    Dialogs, noDate
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      tryOutType: JSON.parse(sessionStorage.getItem('loginUserData')).tryOutType,
      page: 1,
      pageSize: 40,
      pageNum: 0,
      // 发起考核弹框
      dialogExamine: {
        addDounced: false, // 显示新增
        title: '发起考核',
        width: '700px',
        slotName: 'desc',
        date: '',
        templateValue: '',
        templateOptions: [],
        followValue: '',
        followOptions: [],
        userList: [],
        // 人员类型
        auditUserType: '1',
        // 角色
        auditRoles: [],
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '下一步', type: 'primary', fun: this.Examine }
        ]
      },
      // 发起考核预览弹框
      dialogInitiate: {
        addDounced: false, // 显示新增
        title: '发起考核预览',
        width: '80%',
        slotName: 'desc',
        tableData: [],
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog1 },
          { label: '确定', type: 'primary', fun: this.addRoles }
        ]
      },
      // 添加考核项弹框
      dialogaddExamine: {
        addDounced: false, // 显示新增
        title: '考核分类',
        width: '700px',
        slotName: 'desc',
        id: '',
        // 得分
        score: '0',
        // 分类
        sort: '',
        sortOptions: [],
        // 完成标准
        standard: '',
        fieldValueList: [],
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog2 },
          { label: '确定', type: 'primary', fun: this.addExamine }
        ]
      },
      dialogFinsh: {
        addDounced: false, // 显示新增
        title: '',
        width: '800px',
        slotName: 'desc',
        tableData: [],
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog }
          // { label: '确定', type: 'primary', fun: this.addRoles }
        ]
      },
      CurrentAddIndex: null,
      // 开始日期范围
      pickerOptions: {
        disabledDate(time) {
          // 获取当前日期
          const today = new Date()
          // 获取上个月的第一天
          const lastMonthFirstDay = new Date(today.getFullYear(), today.getMonth(), 1)
          // 如果时间大于等于上个月的第一天，则禁用
          return time.getTime() > lastMonthFirstDay.getTime()
        }
      },
      // 角色列表
      roleData: [],
      // 已选角色
      checkedCities: [],
      tableHeaders: []
    }
  },
  methods: {
    getCellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const currentValue = row.typeName
        const previousValue = rowIndex > 0 ? this.dialogInitiate.tableData[rowIndex - 1].typeName : null

        // 仅为第一个可见单元格添加样式
        if (currentValue !== previousValue) {
          return 'merged-cell'
        }
      }
      return ''
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 只处理第一列
        const currentValue = row.typeName
        const previousValue =
          rowIndex > 0 ? this.dialogInitiate.tableData[rowIndex - 1].typeName : null

        if (currentValue === previousValue) {
          return [0, 0] // 让当前单元格隐藏
        } else {
          let count = 1
          for (let i = rowIndex + 1; i < this.dialogInitiate.tableData.length; i++) {
            if (this.dialogInitiate.tableData[i].typeName === currentValue) {
              count++
            } else {
              break
            }
          }
          return [count, 1] // 合并 count 行
        }
      }
    },
    // 发起考核弹框打开
    ExamineOpen() {
      // 默认为上个月
      const today = new Date()
      // const previousMonth = new Date(today.getFullYear(), today.getMonth(), 1)
      const previousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1)
      const year = previousMonth.getFullYear()
      const month = previousMonth.getMonth() + 1
      const dayDate = `${year}/${month >= 10 ? month : '0' + month}`
      this.dialogExamine.date = dayDate.toString()
      this.dialogExamine.templateValue = ''
      this.dialogExamine.followValue = ''
      this.dialogExamine.userList = [
        {
          userid: JSON.parse(sessionStorage.getItem('loginUserData')).userDingId,
          id: JSON.parse(sessionStorage.getItem('loginUserData')).userId,
          name: JSON.parse(sessionStorage.getItem('loginUserData')).userName,
          avatar: JSON.parse(sessionStorage.getItem('loginUserData')).userAvatar
        }
      ]
      this.dialogExamine.addDounced = true
      var meritsUserList = []
      if (this.dialogExamine.userList && this.dialogExamine.userList.length > 0) {
        this.dialogExamine.userList.map((item) => {
          meritsUserList.push({
            'id': item.id
          })
        })
      } else {
        meritsUserList = [{ id: '' }]
      }
      var date = {
        meritsUserList: meritsUserList
      }
      automgetAddBefore(date).then((data) => {
        if (data.code === 10000) {
          this.$nextTick(() => {
            this.dialogExamine.templateValue = data.result.meritsTempList[0].id
            this.dialogExamine.templateOptions = data.result.meritsTempList
            this.dialogExamine.followValue = data.result.meritsFlowList[0].id
            this.dialogExamine.followOptions = data.result.meritsFlowList
            this.followChange(data.result.meritsFlowList[0].id)
          })
        } else {
          this.$message.error(data.info)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },
    // 正常、逾期、提前完成弹框
    CountDialog(row, type) {
      this.dialogFinsh.addDounced = true
      var page = this.page
      var pageSize = this.pageSize
      var date = {}
      if (type === 'normalCount') {
        this.dialogFinsh.title = '正常完成任务列表'
        date.autoType = '0'
        date.meritsId = row.id
      } else if (type === 'exceedCount') {
        this.dialogFinsh.title = '逾期完成任务列表'
        date.autoType = '2'
        date.meritsId = row.id
      } else {
        this.dialogFinsh.title = '提前完成任务列表'
        date.autoType = '1'
        date.meritsId = row.id
      }
      findKpiTaskPageList(page, pageSize, date).then((data) => {
        if (data.code === 10000) {
          this.dialogFinsh.tableData = data.result.list
        } else {
          this.$message.error(data.info)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 钉钉通讯录选人组件
    contactChoose(userids, type) {
      // console.log('choose')
      var that = this
      choose({
        multiple: false, // 是否多选：true多选 false单选； 默认true
        users: userids, // 默认选中的用户列表，员工userid；成功回调中应包含该信息
        corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId, // 企业id
        max: 100, // 人数限制，当multiple为true才生效，可选范围1-1500
        // emplId 员工id
        onSuccess: function(res) {
          if (res.length > 0) {
            var date = {
              users: res
            }
            findUserIds(date)
              .then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  // that.taskFollow(res1.result.userList)
                  if (type === '1') {
                    that.dialogExamine.userList = res1.result.userList
                    var meritsUserList = []
                    that.dialogExamine.userList.map((item) => {
                      meritsUserList.push({
                        'id': item.id
                      })
                    })
                    var date = {
                      meritsUserList: meritsUserList
                    }
                    automgetAddBefore(date).then((data) => {
                      if (data.code === 10000) {
                        that.$nextTick(() => {
                          that.dialogExamine.templateValue = data.result.meritsTempList[0].id
                          that.dialogExamine.templateOptions = data.result.meritsTempList
                          that.dialogExamine.followValue = data.result.meritsFlowList[0].id
                          that.dialogExamine.followOptions = data.result.meritsFlowList
                        })
                      } else {
                        that.$message.error(data.info)
                      }
                    }).catch((err) => {
                      that.$message.error(err)
                    })
                  } else {
                    that.roleData.map((item) => {
                      if (type === item.id) {
                        item.userList = res1.result.userList
                      }
                    })
                  }
                } else {
                  that.$message.warning(
                    res1.result.unAuthUserNameList.join(',') + ' 未授权'
                  )
                }
              })
              .catch((error) => {
                console.log(error)
                //  this.$message.error('网络错误，请稍候！')
              })
          }
        },
        onFail: function(err) {
          console.log(err)
        }
      })
        .then((res) => {
          console.log('then______err', res)
          // alert('$ANTDD error: ' + JSON.stringify(err))
        })
        .catch((err) => {
          console.log('catch______err', err)
          // alert('$ANTDD error: ' + JSON.stringify(err))
        })
    },
    // 企微通讯录选人组件
    wechatLogin(userids, type) {
      var that = this
      if (this.tryOutType === '1') {
        Vue.prototype.$wx.invoke('selectPrivilegedContact', {
          'fromDepartmentId': -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          'mode': 'single', // 必填，选择模式，single表示单选，multi表示多选
          'type': ['user'], // 必填，选择限制类型，指定department、user中的一个或者多个
          'selectedDepartmentIds': [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          'selectedUserIds': userids // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function(res) {
          if (res.err_msg === 'selectPrivilegedContact:ok') {
            if (typeof res.result === 'string') {
              res.result = JSON.parse(res.result) // 由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            const selectedUserList = res.result.userList || [] // 已选的成员列表
            const selectedTicket = res.result.selectedTicket || '' // 已选的成员Ticket列表
            if (selectedUserList.length > 0 || selectedTicket.length > 0) {
              var date = {
                type: 'user',
                users: selectedUserList,
                ticket: selectedTicket
              }
              // alert('数据 ' + JSON.stringify(date))
              findUserIds(date).then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  if (type === '1') {
                    that.dialogExamine.userList = res1.result.userList
                    var meritsUserList = []
                    that.dialogExamine.userList.map((item) => {
                      meritsUserList.push({
                        'id': item.id
                      })
                    })
                    var date = {
                      meritsUserList: meritsUserList
                    }
                    automgetAddBefore(date).then((data) => {
                      if (data.code === 10000) {
                        that.$nextTick(() => {
                          that.dialogExamine.templateValue = data.result.meritsTempList[0].id
                          that.dialogExamine.templateOptions = data.result.meritsTempList
                          that.dialogExamine.followValue = data.result.meritsFlowList[0].id
                          that.dialogExamine.followOptions = data.result.meritsFlowList
                        })
                      } else {
                        that.$message.error(data.info)
                      }
                    }).catch((err) => {
                      that.$message.error(err)
                    })
                  } else {
                    that.roleData.map((item) => {
                      if (type === item.id) {
                        item.userList = res1.result.userList
                      }
                    })
                  }
                  // that.dialogExamine.userList = res1.result.userList
                } else {
                  this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
                }
              }).catch((error) => {
                console.log(error)
              //  this.$message.error('网络错误，请稍候！')
              })
            }
          }
        })
      } else {
        Vue.prototype.$wx.invoke('selectEnterpriseContact', {
          'fromDepartmentId': -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          'mode': 'single', // 必填，选择模式，single表示单选，multi表示多选
          'type': ['user'], // 必填，选择限制类型，指定department、user中的一个或者多个
          'selectedDepartmentIds': [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          'selectedUserIds': userids // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function(res) {
          if (res.err_msg === 'selectEnterpriseContact:ok') {
            if (typeof res.result === 'string') {
              res.result = JSON.parse(res.result) // 由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            const selectedUserList = res.result.userList // 已选的成员列表
            if (selectedUserList.length > 0) {
              var date = {
                users: selectedUserList
              }
              findUserIds(date)
                .then((res1) => {
                  if (res1.code === 10000 && res1.result.isAll) {
                  // that.taskFollow(res1.result.userList)
                    // that.dialogExamine.userList = res1.result.userList
                    if (type === '1') {
                      that.dialogExamine.userList = res1.result.userList
                      var meritsUserList = []
                      that.dialogExamine.userList.map((item) => {
                        meritsUserList.push({
                          'id': item.id
                        })
                      })
                      var date = {
                        meritsUserList: meritsUserList
                      }
                      automgetAddBefore(date).then((data) => {
                        if (data.code === 10000) {
                          that.$nextTick(() => {
                            that.dialogExamine.templateValue = data.result.meritsTempList[0].id
                            that.dialogExamine.templateOptions = data.result.meritsTempList
                            that.dialogExamine.followValue = data.result.meritsFlowList[0].id
                            that.dialogExamine.followOptions = data.result.meritsFlowList
                          })
                        } else {
                          that.$message.error(data.info)
                        }
                      }).catch((err) => {
                        that.$message.error(err)
                      })
                    } else {
                      that.roleData.map((item) => {
                        if (type === item.id) {
                          item.userList = res1.result.userList
                        }
                      })
                    }
                  } else {
                    that.$message.warning(
                      res1.result.unAuthUserNameList.join(',') + ' 未授权'
                    )
                  }
                })
                .catch((error) => {
                  console.log(error)
                //  this.$message.error('网络错误，请稍候！')
                })
            }
          }
        })
      }
    },
    // 飞书选人
    fsContactChoose(userids, type) {
      var multiple = true
      if (type === 0) {
        multiple = false
      } else {
        multiple = true
      }
      feishuContactChoose(userids, multiple).then((res) => {
        if (res.length > 0) {
          const result = res.map(item => ({ id: item.openId }))
          var date = {
            users: result
          }
          findUserIds(date).then((res1) => {
            if (res1.code === 10000 && res1.result.isAll) {
              // that.taskFollow(res1.result.userList)
              if (type === '1') {
                this.dialogExamine.userList = res1.result.userList
                var meritsUserList = []
                this.dialogExamine.userList.map((item) => {
                  meritsUserList.push({
                    'id': item.id
                  })
                })
                var date = {
                  meritsUserList: meritsUserList
                }
                automgetAddBefore(date).then((data) => {
                  if (data.code === 10000) {
                    this.$nextTick(() => {
                      this.dialogExamine.templateValue = data.result.meritsTempList[0].id
                      this.dialogExamine.templateOptions = data.result.meritsTempList
                      this.dialogExamine.followValue = data.result.meritsFlowList[0].id
                      this.dialogExamine.followOptions = data.result.meritsFlowList
                    })
                  } else {
                    this.$message.error(data.info)
                  }
                }).catch((err) => {
                  this.$message.error(err)
                })
              } else {
                this.roleData.map((item) => {
                  if (type === item.id) {
                    item.userList = res1.result.userList
                  }
                })
              }
            } else {
              this.$message.warning(
                res1.result.unAuthUserNameList.join(',') + ' 未授权'
              )
            }
          }).catch((error) => {
            console.log(error)
          })
        }
      })
    },
    // 添加人员
    contactCh(responseUserList, type) {
      var userids = []
      if (responseUserList) {
        responseUserList.map((item) => {
          userids.push(item.userid)
        })
      }
      if (this.channel === 'ding') {
        this.contactChoose(userids, type)
      } else if (this.channel === 'wechat') {
        this.wechatLogin(userids, type)
      } else {
        this.fsContactChoose(userids, type)
      }
    },
    // 选择角色
    checkedChange() {
      console.log('选择角色')
    },
    // 选择人员类型
    Personnelnode(command) {
      if (command === '1') {
        this.contactCh(this.dialogExamine.userList)
      } else {
        console.log('获取角色')
      }
    },
    // 删除人员
    delUsers(responseUserList, index, type) {
      if (type === '1') {
        this.dialogExamine.userList.splice(index, 1)
      } else {
        this.roleData.map((item) => {
          if (item.id === responseUserList.id) {
            item.userList.splice(index, 1)
          }
        })
      }
    },
    // 自定义列表
    tempFieldFindList() {
      var date = {
        tempId: this.dialogExamine.templateValue
      }
      tempFieldFindList(date).then((data) => {
        if (data.code === 10000) {
          // data.result.forEach(item => {
          //   item.value = '' // 你可以根据需要设置 value 的值
          // })
          // this.tableHeaders = data.result.map((item, index) => ({
          //   label: `${item.name}`,
          //   prop: `${item.key}`,
          //   id: `${item.id}`
          // }))
          // this.tempFieldsList = data.result
          console.log(this.tableHeaders, 'this.tableHeaders')
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 发起考核下一步
    Examine() {
      var checkoutFlag = true
      if (this.dialogExamine.date === '') {
        this.$message.error('请选择考核日期')
        checkoutFlag = false
        return false
      } else if (this.dialogExamine.templateValue === '') {
        this.$message.error('请选择评分模板')
        checkoutFlag = false
        return false
      } else if (this.dialogExamine.userList.length === 0) {
        this.$message.error('请选择考核人员')
        checkoutFlag = false
        return false
      } else if (this.dialogExamine.followValue === '') {
        this.$message.error('请选择评分流程')
        checkoutFlag = false
        return false
      } else {
        this.roleData.forEach(item => {
          if (item.userList.length === 0) {
            this.$message.error(`${item.name}的人员不能为空`)
            checkoutFlag = false
            return false
          }
        })
      }
      if (checkoutFlag === true) {
        var meritsUserList = []
        if (this.dialogExamine.userList && this.dialogExamine.userList.length > 0) {
          this.dialogExamine.userList.map((item) => {
            meritsUserList.push(
              {
                id: item.id
              }
            )
          })
        }
        var date = {
          meritsDate: this.dialogExamine.date,
          meritsUserList: meritsUserList,
          tempId: this.dialogExamine.templateValue,
          flowId: this.dialogExamine.followValue
        }
        meritsfindPre(date).then((data) => {
          if (data.code === 10000) {
            this.dialogExamine.addDounced = false
            this.dialogInitiate.addDounced = true
            this.dialogInitiate.tableData = data.result
            data.result.map((item) => {
              item.fieldValueList.forEach(item => {
                item.value = '' // 你可以根据需要设置 value 的值
              })
              this.tableHeaders = item.fieldValueList.map((itemD, index) => ({
                label: `${itemD.name}`,
                prop: `${itemD.key}`,
                id: `${itemD.id}`
              }))
            })
            this.tempFieldFindList()
          } else {
            this.$message.error(data.info)
          }
        }).catch((err) => {
          this.$message.error(err)
        })
      }
    },
    // 发起考核确定
    addRoles() {
      this.dialogInitiate.addDounced = false
      var meritsUserList = []
      if (this.dialogExamine.userList && this.dialogExamine.userList.length > 0) {
        this.dialogExamine.userList.map((item) => {
          meritsUserList.push({
            id: item.id
          })
        })
      }
      // 角色
      const newData = this.roleData.map(item => {
        const userIds = item.userList.map(user => user.id)
        const newUserId = userIds.join(',')
        return {
          ...item,
          userId: newUserId
        }
      })
      var date = {
        meritsDate: this.dialogExamine.date,
        meritsUserList: meritsUserList,
        tempId: this.dialogExamine.templateValue,
        flowId: this.dialogExamine.followValue,
        detailList: this.dialogInitiate.tableData,
        roleList: newData
      }
      console.log(date, 'date')
      meritsSave(date).then((data) => {
        if (data.code === 10000) {
          this.$message.success('发起考核成功！')

          this.$parent.getUserKPIList()
          this.$parent.checkdetail(data.result, '')
        } else {
          this.$message.error(data.info)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },
    // 分类修改
    sortChange(val) {
      var date = {
        tempId: this.dialogExamine.templateValue
      }
      tempTypeList(date).then((data) => {
        if (data.code === 10000) {
          if (data.result && data.result.length > 0) {
            const filteredData = data.result.filter(item => item.type !== '0')
            this.dialogaddExamine.sortOptions = filteredData
          } else {
            this.dialogaddExamine.sortOptions = []
            this.$message.error('请先创建分类')
          }
          this.$forceUpdate()
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 自定义字段描述
    tempFieldsChange(e, item, index, list) {
      console.log(e, item, index, list, this.dialogInitiate.tableData, '自定义字段')
    },
    // 添加考核确定
    addExamine() {
      this.dialogaddExamine.addDounced = false
      var typeName = ''
      var typeId = ''
      var typeScore = ''
      if (this.dialogaddExamine.sortOptions && this.dialogaddExamine.sortOptions.length > 0) {
        this.dialogaddExamine.sortOptions.map((item) => {
          if (this.dialogaddExamine.sort === item.id) {
            typeName = item.name
            typeId = item.id
            typeScore = item.score
          }
        })
      }
      const fieldValueMap = this.dialogaddExamine.fieldValueList.reduce((acc, item) => {
        acc[item.key] = item.value
        return acc
      }, {})
      var newItem = {
        score: this.dialogaddExamine.score,
        typeName: typeName,
        content: this.dialogaddExamine.standard,
        typeId: typeId,
        typeScore: typeScore,
        fieldValueList: this.dialogaddExamine.fieldValueList,
        fieldValueMap: fieldValueMap
      }
      // 获取插入位置
      var findIndex = this.dialogInitiate.tableData.length - 1
      for (var i = this.dialogInitiate.tableData.length - 1; i >= 0; i--) {
        if (this.dialogInitiate.tableData[i].typeName === typeName) {
          findIndex = i
          break
        }
      }
      this.dialogInitiate.tableData.splice(findIndex + 1, 0, newItem)
      // this.dialogInitiate.tableData.map((item) => {
      //   this.tableHeaders = item.fieldValueList
      // })
    },
    // 评分
    changeScore(e, row) {
      console.log(e, row)
    },
    // 提交修改
    submitInfo() {
      var date = {
        id: this.detailInfo.id
      }
      meritSubmit(date).then((data) => {
        if (data.code === 10000) {
          this.$message.warning(data.result)
        } else {
          this.$message.error(data.info)
        }
      })
    },
    // 添加评分
    handleEdit(index, row) {
      this.CurrentAddIndex = index
      this.dialogaddExamine.addDounced = true
      this.dialogaddExamine.sort = row.typeId
      this.dialogaddExamine.standard = ''
      this.dialogaddExamine.score = '0'
      this.sortSelect(row.typeId)
      this.sortChange()
    },
    // 评分分类选择
    sortSelect(e) {
      var date = {

        id: '',
        tempId: this.dialogExamine.templateValue,
        typeId: e
      }
      ConfigDetail(date).then((data) => {
        if (data.code === 10000) {
          this.dialogaddExamine.score = data.result.maxScore
          this.dialogaddExamine.fieldValueList = data.result.fieldValueList
        } else {
          this.$message.error(data.info)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 完成标准修改
    FinstandardChange(val) {
      this.dialogaddExamine.standard = val
    },
    // 删除考核预览
    handleDelete(index, row) {
      if (row.type === '0') {
        this.$confirm('此操作将删除该任务, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var date = {
            taskId: row.taskId
          }
          closeTaskKpi(date).then((data) => {
            if (data.code === 10000) {
              this.dialogInitiate.tableData.splice(index, 1)
            } else {
              this.$message.error(data.info)
            }
          }).catch((error) => {
            console.log(error)
          })
        }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
        })
      } else {
        this.dialogInitiate.tableData.splice(index, 1)
      }
    },
    // 考核日期
    ExamineChange(e) {
      this.dialogExamine.date = e
    },
    // 评分模板选择
    templateChange(e) {
      this.dialogExamine.templateValue = e
    },
    // 评分流程修改
    followChange(e) {
      this.dialogExamine.followValue = e
      var date = {
        flowId: e
      }
      getRoleByFlowId(date).then((data) => {
        if (data.code === 10000) {
          this.roleData = data.result
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 单元格方法
    returnName(obj) {
      if (obj.column.label === '任务状态') {
        if (obj.row.status === '0') {
          return 'tableTextColor tableTextColor1'
        } else if (obj.row.status === '1') {
          return 'tableTextColor tableTextColor2'
        } else if (obj.row.status === '2') {
          return 'tableTextColor tableTextColor6'
        } else if (obj.row.status === '3') {
          return 'tableTextColor tableTextColor5'
        } else if (obj.row.status === '4') {
          return 'tableTextColor tableTextColor7'
        }
      }
    },
    // 弹框关闭
    beforeClose() {
      this.dialogFinsh.addDounced = false
      this.dialogInitiate.addDounced = false
      this.dialogExamine.addDounced = false
    },
    beforeClose1() {
      this.dialogMark.addDounced = false
    },
    // 弹框取消
    cancelDialog() {
      this.dialogFinsh.addDounced = false
      this.dialogExamine.addDounced = false
      this.dialogInitiate.addDounced = false
    },
    cancelDialog1() {
      this.dialogInitiate.addDounced = false
      this.dialogExamine.addDounced = true
    },
    cancelDialog2() {
      this.dialogaddExamine.addDounced = false
      this.dialogInitiate.addDounced = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/index.scss';
// 评分弹框
.info_subject {
  display: flex;
  align-items: flex-start;
  font-size: $font_14;
  font-family: $font_family1;
  font-weight: 400;
  color: $color_6;
  line-height: 22px;
  margin: 18px 14px;
  .info_subject_option {
    display: flex;
    width: 100%;
  }
  .info_subject_option_title{
      width: 70px;
      margin-right: 16px;
      height: 32px;
      font-family: $font_family1;
      font-weight: 400;
      font-size: 15px;
      color: #666666;
      line-height: 31px;
      text-align: left;
      font-style: normal;
      overflow: hidden;
      text-overflow: ellipsis;
    white-space: nowrap;
      cursor: pointer;
  }
}
.input_box {
  width: 532px;
  height: 30px;
  line-height: 28px;
  border: 1px solid #DCDFE6;
  border-radius: 6px;
  // background: #f5f5f5;
  display: flex;
  align-items: center;
  cursor: pointer;
  .input_name {
    width: 164px;
    margin: 0 10px;
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .input {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: $color_9;
      position: relative;
    }
  }

}
.input:hover .del_icon {
  display: block;
}
.del_icon{
  font-size: $font_12;
  color: $color_9;
  line-height: 16px;
  position: absolute;
  top: -1px;
  right: -6px;
  display: none;
  cursor: pointer;
}
.del_icon:hover {
  color: $color_main;
}
::v-deep .tableTextColor div span{
  font-size: $font_12;
  border-radius: 4px;
  line-height: 20px;
  padding: 2px 8px;
  display: inline-block;
  margin: auto;
}
::v-deep .tableTextColor8 div {
  line-height: 20px;
  padding: 2px 8px;
  display: inline-block;
  margin: auto;
  color: #fa7068;
}
// 未指派
.tableTextColor1 div span{
  color: #f1ad38;
  background: rgba(241, 173, 56, 0.1);
}
// 未完成
.tableTextColor2 div span{
  color: #74bf7a;
  background: rgba(116, 191, 122, 0.1);
}
// 待测试
.tableTextColor3 div span{
  color: #ff9c95;
  background: rgba(255, 156, 149, 0.1);
}
// 测试中
.tableTextColor4 div span{
  color: #fa7068;
  background: rgba(250, 112, 104, 0.1);
}
// 待确认
.tableTextColor5 div span{
  color: #8fb9ff;
  background: rgba(143, 185, 255, 0.1);
}
// 已完成
.tableTextColor6 div span{
  color: $color_main;
  background: rgba(40, 120, 255, 0.1);
}
// 已终止
.tableTextColor7 div span{
  color: #a8a8a8;
  background: rgba(168, 168, 168, 0.1);
}
::v-deep .el-textarea .el-textarea__inner {
  height: 80px !important;
}

::v-deep .el-table .cell {
  height: auto !important;
  line-height: normal !important;
  padding: 10px !important;
  box-sizing: border-box;
}
::v-deep .el-table--border .el-table__cell {
  border-right: none;
}
::v-deep .merged-cell {
  border-right: 1px solid #EBEEF5 !important;
}
// ::v-deep .merged-cell-l {
//   border-left: 1px solid #EBEEF5 !important;
// }
.add_icon:hover {
  color: $color_main;
  cursor: pointer;
}
.add_icon {
  font-size: 20px;
  color: #909090;
}
.user_personnel {
  position: relative;
  display: flex;
  align-items: center;
  // width: 85px;
  // padding: 4px 0;
  border-radius: 4px;
}
.user_personnel:hover {
  // width: 65px;
  // padding: 4px 10px;
  background: #f6f6f6;
}
.user_personnel:hover .del_icon {
  display: block;
}
.info_personnel {
  // min-width: 65px;
  font-size: $font_12;
  font-family: $font_family;
  font-weight: 400;
  color: $color_4;
  padding: 4px 15px 4px 10px;
  line-height: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.info_personnel_surname {
  width: 25px;
  height: 25px;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_white;
  line-height: 25px;
  text-align: center;
  color: $color_white;
  background: $color_main;
  border-radius: 50%;
  margin-right: 10px !important;
  vertical-align: middle;
}
.info_personnel_followUsers{
  height: 37px;
}
.users_personnel{
  width: 100%;
  display: flex;
  // justify-content: space-between;
  align-items: flex-start;
  // flex-wrap: wrap;
  margin-left: 9px;
  margin-top: 20px;
}
::v-deep .table-box .el-table__body-wrapper {
  height: calc(100vh - 540px) !important;
  overflow: auto !important;
}
::v-deep .el-dialog__body {
    padding: 30px 15px !important;
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  // height: 10px;
  z-index: 9999999;
}
::v-deep .table-box .el-table__fixed {
  height: 100% !important;
}
::v-deep .table-box .el-table__fixed-right {
  height: 100% !important;
}
::v-deep .el-table--scrollable-y .el-table__body-wrapper {
  // padding-bottom: 18px !important;
  // height: 100% !important;
}
</style>
